<template>
    <div class="page page__list">
        <search-bar @search="onSearch" name="pr_code,pr_detail,pr_orispeccode,pr_spec" placeholder="输入物料进行查找" ref="searchBar" />
        <div class="x-header-center">
            <span v-if="items && items.length">{{ items[0].dt_cop }}</span>
            <span v-else>暂无数据</span>
        </div>
        <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
            <router-link class="weui-cell weui-cell_access" v-for="item in items" :key="item.id"
                :to="{ name: 'SaleDeliveryReply', params: { item } }">
                <div class="weui-cell__bd">
                    <p>{{ item.dt_code }}</p>
                    <p v-format="'yyyy-MM-dd'">{{ item.dt_delivery }}</p>
                </div>
                <div class="weui-cell__ft">
                    <p>{{ item.pr_detail }}</p>
                    <p class="list-item-muted">{{ item.pr_code }}</p>
                </div>
            </router-link>
        </scroll-list>
        <div class="list-footer">
            <label class="list-footer__label">合计：{{ items.length }}</label>
        </div>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
    components: {
        SearchBar,
        ScrollList,
    },
    mixins: [list],
    data() {
        return {
            otherCondition: null,
            listUrl: "/api/purchase/delivery/deliverytrace/sale/list",
            params: {
                mode: "MAIN",
                number: 1,
                size: 99999
            }
        }
    },
    methods: {
        onSearch(callback, next) {
            this.setQueryCondition();
            var callbackFn = typeof callback === 'function' ? callback : null;
            this.doSearch(callbackFn, next);
        },
        setQueryCondition() {
            var me = this, otherCondition = [];
            // 指定追踪请求ID
            var reqId = me.$route.query.rid;
            if (reqId) {
                otherCondition.push({
                    f: 'dt_reqid',
                    v: reqId
                })
            }
            // 指定客户的交期追踪
            var custCompanyId = me.$route.query.cid;
            if (custCompanyId) {
                otherCondition.push({
                    t: 'number',
                    f: 'DeliveryTrace.companyId',
                    v: custCompanyId
                })
            }
            me.otherCondition = otherCondition;
        }
    }
}
</script>

<style scoped>
.x-header-center {
    padding: 10px;
    text-align: center;
    background: var(--weui-BG-2);
    border-bottom: 1px solid var(--weui-FG-3);
    font-size: 16px;
}
</style>